// FormSubmissionsTab.jsx
import React from "react";
import { useTable, useSortBy } from "react-table";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { DefaultArrow, DownArrow, UpArrow } from "../../../Resident/sortArrows";
import moment from "moment/moment";
import FormSubmissionDetail from "./FormSubmissionDetail";
import EditFormSubmission from "./EditFormSubmission";

const FormSubmissionsTabFSARR = () => {
  const state = useSelector((state) => ({
    organizationName: state.organization.name,
    affiliateMemberId: state.affiliateMember.id,
    currentUser: state.currentUser.id
  }));

  const [formSubmissions, setFormSubmissions] = React.useState([]);
  const [expandedRows, setExpandedRows] = React.useState({});
  const [detailsCache, setDetailsCache] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [editModeRows, setEditModeRows] = React.useState({});

  const fetchFacilities = () => {
    const { organizationName, affiliateMemberId } = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_submissions.json?${$.param({ page: currentPage })}`,
      success: (response) => {
        setFormSubmissions(response.form_submissions);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    });
  };

  const toggleRow = (id) => {
    const { organizationName, affiliateMemberId } = state;
    const isExpanded = expandedRows[id];

    if (!isExpanded && !detailsCache[id]) {
      $.ajax({
        url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_submissions/${id}.json`,
        success: (response) => {
          setDetailsCache((prev) => ({ ...prev, [id]: response }));
          setExpandedRows((prev) => ({ ...prev, [id]: true }));
        }
      });
    } else {
      setExpandedRows((prev) => ({ ...prev, [id]: !isExpanded }));
    }
  };

  const columns = React.useMemo(() => [
    {
      Header: "Name",
      accessor: "submission_name",
      Cell: ({ row, value }) => {
        const isExpanded = expandedRows[row.original.id];
  
        return (
          <div
            className="d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              toggleRow(row.original.id);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className={`fas ${isExpanded ? "fa-chevron-down mr-2 mt-1" : "fa-chevron-right mr-2 mt-1"}`} />
            <span>{value}</span>
          </div>
        );
      }
    },
    { Header: "Submitted Date", accessor: "submission_date" },
    { Header: "Accepted/Rejected", accessor: "display_status" },
    { Header: "Notes", accessor: "display_short_notes" },
  ], [expandedRows]);

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: formSubmissions,
      manualSorting: true,
    },
    useSortBy
  );

  React.useEffect(() => {
    fetchFacilities();
  }, [currentPage]);

  return (
    <>
      <table {...getTableProps()} className="table table-hover">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {rows.map((row) => {
            prepareRow(row);
            const rowId = row.original.id;

            return (
              <React.Fragment key={rowId}>
                <tr
                  {...row.getRowProps({
                    onClick: () => toggleRow(rowId),
                    style: { cursor: 'pointer' },
                  })}
                >
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>

                {expandedRows[rowId] && (
                  <tr>
                    <td colSpan={columns.length}>
                      <div className="p-3 bg-light border rounded">
                        {editModeRows[rowId] ? (
                          <EditFormSubmission
                            submission={detailsCache[rowId]}
                            currentUser={state.currentUser}
                            onCancel={() => setEditModeRows((prev) => ({ ...prev, [rowId]: false }))}
                            onUpdated={(updated) => {
                              setDetailsCache((prev) => ({ ...prev, [rowId]: updated }));

                              setFormSubmissions((prev) =>
                                prev.map((submission) =>
                                  submission.id === updated.id
                                    ? { ...submission, display_short_notes: updated.reviews?.[0]?.notes || '', display_status: updated.reviews?.[0]?.status === 'declined' ? 'Rejected' : 'Accepted' }
                                    : submission
                                )
                              );
                            }}
                          />
                        ) : (
                          <FormSubmissionDetail
                            submission={detailsCache[rowId]}
                            organizationName={state.organizationName}
                            affiliateMemberId={state.affiliateMemberId}
                            currentUser={state.currentUser}
                            onEdit={(id) =>
                              setEditModeRows((prev) => ({ ...prev, [id]: true }))
                            }
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

      {totalPages > 1 && (
        <ReactPaginate
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          pageCount={totalPages}
          onPageChange={(page) => setCurrentPage(page.selected + 1)}
        />
      )}
    </>
  );
};

export default FormSubmissionsTabFSARR;
